import { Component, OnInit } from '@angular/core';
import { CourseService } from 'src/app/services/course.service';

@Component({
  selector: 'app-course-list',
  templateUrl: './course-list.component.html',
  styleUrls: ['./course-list.component.scss']
})
export class CourseListComponent implements OnInit {

  constructor(private courseService: CourseService) { }
  public selectedTopic: any = 'all';
  public courses: any = {};
  public searchText: any = '';
  public isLoading: boolean = false;
  public categories: any[] = [
    'Clinical Chemistry',
    'Clinical Pathology',
    'Hematology',
    'Immunoassay',
    'Quality Assurance',
    'Samples & Pre-Analytics',
    'Micro-Biology',
    'General',
    'Transfusion Medicine',
    'Sample Courses'
  ];

  ngOnInit(): void {
    this.getAllCourses();
  }

  onSelectTopic(topic) {
    this.selectedTopic = this.selectedTopic == topic ? 'all' : topic;
  }

  onSearch(event) {
    this.searchText = event;
    this.getAllCourses();
  }

  getAllCourses() {
    let filter = this.selectedTopic !== 'all' ? this.selectedTopic : '';
    let searchText = this.searchText;
    let body = {
      category: filter,
      searchText: searchText
    }
    this.isLoading = true;
    this.courseService.getAllPublishedCourses(body).subscribe(
      (res: any) => {
        for (let i = 0; i < this.categories.length; i++) {
          this.courses[this.categories[i]] = [];
        }
        for (let i = 0; i < res.length; i++) {
          if (res[i].price == 0) {
            this.courses['Sample Courses'].push(res[i]);
          }
          else
            this.courses[res[i].category].push(res[i]);
        }
        this.isLoading = false;
      }
    )
  }
}
